export default "__VITE_ASSET__0d5288e5__"